module.exports = __webpack_public_path__ + "img/ar_my_set.1210b4c6.svg";